/* yambaba-category-nav.js — header nav aligns to visible search field */
(function () {
  var desktop = window.matchMedia("(min-width: 990px)");

  function closestNav(el) {
    return el && el.closest ? el.closest("[data-yb-cat-nav]") : null;
  }

  function verticalWrap() {
    return document.querySelector(".header-search-vertical");
  }

  function restorePanels() {
    document.querySelectorAll(".yb-cat-l2-panel.is-portaled").forEach(function (panel) {
      var item = document.querySelector('[data-yb-panel-id="' + panel.id + '"]');
      if (item) item.appendChild(panel);
      panel.classList.remove("is-portaled", "is-open");
      panel.removeAttribute("style");
    });
  }

  function setFlyoutOpen(open) {
    var wrap = verticalWrap();
    if (wrap) wrap.classList.toggle("yb-cat-flyout-open", !!open);
  }

  function hideAll() {
    document.querySelectorAll(".yb-cat-l1-item.is-open").forEach(function (item) {
      item.classList.remove("is-open");
      var btn = item.querySelector("[data-yb-toggle]");
      if (btn) btn.setAttribute("aria-expanded", "false");
    });
    document.querySelectorAll(".yb-cat-l2-panel.is-open").forEach(function (panel) {
      panel.classList.remove("is-open");
    });
    setFlyoutOpen(false);
  }

  function showPair(item) {
    if (!item) return;
    document.querySelectorAll(".yb-cat-l1-item.is-open").forEach(function (other) {
      if (other !== item) other.classList.remove("is-open");
    });
    item.classList.add("is-open");
    var panel = item.querySelector(".yb-cat-l2-panel");
    if (panel) panel.classList.add("is-open");
    setFlyoutOpen(true);
    var btn = item.querySelector("[data-yb-toggle]");
    if (btn) btn.setAttribute("aria-expanded", "true");
  }

  function clearBrokenNavInline() {
    document.documentElement.style.removeProperty("--yb-nav-left");
    document.documentElement.style.removeProperty("--yb-nav-max");
    document.querySelectorAll(".header-bottom ul.menu-listing, .yb-cat-l1").forEach(function (ul) {
      ["position", "left", "right", "top", "transform", "max-width", "width", "margin"].forEach(function (prop) {
        ul.style.removeProperty(prop);
      });
    });
  }

  function uniquifySidebarThumbs() {
    var seen = {};
    document.querySelectorAll(".yb-collection-cats__thumb img").forEach(function (img) {
      var src = (img.currentSrc || img.getAttribute("src") || "").split("?")[0];
      if (!src) return;
      if (seen[src]) {
        var span = document.createElement("span");
        span.className = "yb-collection-cats__thumb-fallback";
        span.setAttribute("aria-hidden", "true");
        img.replaceWith(span);
        return;
      }
      seen[src] = true;
    });
  }

  function setHeaderOffset() {
    var header = document.querySelector("#shopify-section-header-02 .header-wrapper") ||
      document.querySelector("sticky-header") ||
      document.querySelector("#shopify-section-header-02");
    if (!header) return;
    var h = Math.round(header.getBoundingClientRect().height);
    if (h > 40) document.documentElement.style.setProperty("--yb-header-offset", h + "px");
  }

  function tightenCollectionBanner() {
    if (!document.body || !document.body.classList.contains("template-collection")) return;
    var hero = document.querySelector(".yb-collection-hero");
    var caption = document.querySelector(".yb-collection-hero__caption");
    if (hero && caption && caption.parentElement !== hero) hero.appendChild(caption);
    document.querySelectorAll(
      ".template-collection .page-header, .template-collection .collection-banner-content, .template-collection .collection-breadcrumb, .template-collection .collection-banner .not_img, .template-collection .collection-header .not_img",
    ).forEach(function (el) {
      el.style.setProperty("display", "none", "important");
      el.style.setProperty("height", "0", "important");
      el.setAttribute("hidden", "");
    });
    document.querySelectorAll(
      ".collection-header, .collection-header-in, .collection-banner-img, .collection-banner, .collection-banner-content",
    ).forEach(function (el) {
      el.style.setProperty("min-height", "0", "important");
      el.style.setProperty("height", "auto", "important");
      el.style.setProperty("overflow", "visible", "important");
      el.style.setProperty("margin-bottom", "0", "important");
      el.style.setProperty("padding-top", "0", "important");
      el.style.setProperty("padding-bottom", "0", "important");
    });
    document.querySelectorAll(".yb-collection-hero__title, .yb-collection-hero__kicker, .yb-collection-hero__caption").forEach(function (el) {
      el.style.setProperty("min-height", "0", "important");
      el.style.setProperty("height", "auto", "important");
      el.style.setProperty("line-height", "1.1", "important");
    });
    document.querySelectorAll(".collection-banner-img").forEach(function (el) {
      el.style.setProperty("position", "relative", "important");
      el.style.setProperty("inset", "auto", "important");
    });
  }

  function polishLayout() {
    clearBrokenNavInline();
    setHeaderOffset();
    uniquifySidebarThumbs();
    tightenCollectionBanner();
  }

  document.addEventListener("DOMContentLoaded", restorePanels);
  document.addEventListener("DOMContentLoaded", polishLayout);
  window.addEventListener("resize", polishLayout);
  window.addEventListener("load", polishLayout);
  document.addEventListener("shopify:section:load", polishLayout);
  if (document.readyState !== "loading") {
    restorePanels();
    polishLayout();
  }
  window.setTimeout(polishLayout, 0);
  window.setTimeout(polishLayout, 250);
  window.requestAnimationFrame(polishLayout);

  var hideTimer = null;
  function cancelHide() {
    if (hideTimer) {
      clearTimeout(hideTimer);
      hideTimer = null;
    }
  }
  function scheduleHide() {
    cancelHide();
    hideTimer = setTimeout(hideAll, 160);
  }

  function inFlyout(target) {
    if (!target || !target.closest) return false;
    return !!(
      target.closest("[data-yb-cat-nav]") ||
      target.closest(".yb-cat-l2-panel") ||
      target.closest(".header-search-vertical") ||
      target.closest(".vertical-menu-title")
    );
  }

  document.addEventListener("mouseover", function (event) {
    if (!desktop.matches) return;
    if (inFlyout(event.target)) {
      cancelHide();
      setFlyoutOpen(true);
      var item = event.target.closest(".yb-cat-l1-item");
      if (item && closestNav(item)) showPair(item);
      return;
    }
    scheduleHide();
  });

  document.addEventListener(
    "wheel",
    function (event) {
      var panel = event.target.closest && event.target.closest(".yb-cat-l2-panel");
      if (!panel || !desktop.matches) return;
      event.preventDefault();
      event.stopPropagation();
      panel.scrollTop += event.deltaY;
    },
    { passive: false, capture: true },
  );

  document.addEventListener("click", function (event) {
    var toggle = event.target.closest && event.target.closest("[data-yb-toggle]");
    if (toggle) {
      var item = toggle.closest(".yb-cat-l1-item");
      if (!item) return;
      event.preventDefault();
      event.stopPropagation();
      if (item.classList.contains("is-open")) hideAll();
      else showPair(item);
      return;
    }
    if (desktop.matches) return;
    var parentLink = event.target.closest && event.target.closest("[data-yb-parent-link]");
    if (!parentLink) return;
    var parentItem = parentLink.closest(".yb-cat-l1-item");
    if (!parentItem || !parentItem.classList.contains("has-children")) return;
    if (parentItem.classList.contains("is-open")) return;
    event.preventDefault();
    event.stopPropagation();
    showPair(parentItem);
  });

  document.addEventListener(
    "keydown",
    function (event) {
      if (event.key === "Escape") hideAll();
    },
    true,
  );

  window.addEventListener("resize", hideAll);

  function hideDemoCollectionMenu() {
    var blocked = [
      "/collections/home-furniture-collection",
      "/collections/mobile-laptop",
      "/collections/home-party",
    ];
    var blockedTitles = ["furniture", "laptops", "smart phones", "party"];
    document.querySelectorAll("a[href]").forEach(function (a) {
      var href = (a.getAttribute("href") || "").split("?")[0];
      var title = (a.textContent || "").replace(/\s+/g, " ").trim().toLowerCase();
      var hrefBlocked = blocked.some(function (b) { return href.indexOf(b) !== -1; });
      var titleBlocked = blockedTitles.indexOf(title) !== -1;
      if (!hrefBlocked && !titleBlocked) return;
      if (a.closest("[data-yb-collection-cats]")) return;
      if (a.closest("[data-yb-cat-nav]")) return;
      if (a.closest("footer, .footer")) return;
      if (!a.closest(".sidebar, .collection-sidebar, .facets, aside")) return;
      var item = a.closest("li") || a;
      item.style.display = "none";
      item.setAttribute("hidden", "");
    });
    document.querySelectorAll("h2, h3, h4, .widget-title, .sidebar-title").forEach(function (heading) {
      if ((heading.textContent || "").trim().toLowerCase() !== "categories") return;
      if (heading.closest("[data-yb-collection-cats]")) return;
      if (heading.closest("footer, .footer, .yb-footer-cats-column")) return;
      if (!heading.closest(".sidebar, .collection-sidebar, .facets, aside, .sidebarBlock")) return;
      var box = heading.closest(".sidebar-widget, .widget, .facets-wrapper, .sidebarBlock, .block") || heading.parentElement;
      if (box && document.querySelector("[data-yb-collection-cats]")) box.style.display = "none";
    });
  }

  function fixFooterCategories() {
    var row = document.querySelector(".footer .footer-row, footer .footer-row");
    if (!row) return;
    row.querySelectorAll(".footer-block__heading").forEach(function (heading) {
      if ((heading.textContent || "").trim().toLowerCase() !== "categories") return;
      var item = heading.closest(".footer-block__item");
      if (item && !item.classList.contains("yb-footer-cats-column")) item.style.display = "none";
    });
    var cats = row.querySelector(".yb-footer-cats-column");
    var customer = null;
    row.querySelectorAll(".footer-block__heading").forEach(function (heading) {
      if ((heading.textContent || "").trim().toLowerCase() === "customer service") {
        customer = heading.closest(".footer-block__item");
      }
    });
    if (cats && customer) customer.after(cats);
  }

  document.addEventListener("click", function (event) {
    var btn = event.target.closest && event.target.closest("[data-yb-side-toggle]");
    if (!btn) return;
    var parent = btn.closest(".yb-collection-cats__parent");
    if (!parent) return;
    event.preventDefault();
    var open = !parent.classList.contains("is-open");
    parent.classList.toggle("is-open", open);
    btn.setAttribute("aria-expanded", open ? "true" : "false");
  });

  document.addEventListener("DOMContentLoaded", function () {
    hideDemoCollectionMenu();
    fixFooterCategories();
    layoutShopAllMosaic();
    redirectEmptySearch();
    enhanceMobileDrawer();
  });
  if (document.readyState !== "loading") {
    hideDemoCollectionMenu();
    fixFooterCategories();
    layoutShopAllMosaic();
    redirectEmptySearch();
    enhanceMobileDrawer();
  }

  function enhanceMobileDrawer() {
    var list = document.querySelector(".mobile-menu-scroll .menu-listing");
    if (!list || list.getAttribute("data-yb-enhanced")) return;
    list.setAttribute("data-yb-enhanced", "1");

    var existing = {};
    list.querySelectorAll("a[href]").forEach(function (a) {
      existing[a.getAttribute("href").replace(/\/$/, "")] = true;
    });

    var template = list.querySelector("li.menu-lv-1");
    function makeItem(label, href) {
      var li = document.createElement("li");
      li.className = template ? template.className : "menu-item menu-lv-item menu-lv-1 text-left";
      var a = document.createElement("a");
      var tplLink = template && template.querySelector("a");
      a.className = tplLink ? tplLink.className : "menu-lv-1__action header__menu-item list";
      a.href = href;
      a.textContent = label;
      li.appendChild(a);
      return li;
    }

    if (!existing["/collections/all"]) {
      list.insertBefore(makeItem("Shop all", "/collections/all"), list.firstChild);
    }

    // Append parent categories missing from the curated drawer menu.
    document
      .querySelectorAll(".yb-cat-nav .yb-cat-l1 > li > .yb-cat-l1-row > a[data-yb-parent-link]")
      .forEach(function (a) {
        var href = a.getAttribute("href").replace(/\/$/, "");
        if (existing[href]) return;
        existing[href] = true;
        list.appendChild(makeItem(a.textContent.trim(), href));
      });
  }

  function layoutShopAllMosaic() {
    if (!document.querySelector(".yb-shop-all")) return;
    document.body.classList.add("yb-shop-all-page");
    document.querySelectorAll("[data-yb-shop-mosaic]").forEach(function (grid) {
      var tiles = Array.prototype.slice.call(grid.children);
      var featured = tiles.filter(function (tile) {
        return tile.classList.contains("yb-shop-tile--lg");
      });
      var rest = tiles.filter(function (tile) {
        return !tile.classList.contains("yb-shop-tile--lg");
      });
      for (var i = rest.length - 1; i > 0; i--) {
        var j = Math.floor(Math.random() * (i + 1));
        var tmp = rest[i];
        rest[i] = rest[j];
        rest[j] = tmp;
      }
      rest.forEach(function (tile, index) {
        tile.classList.remove("yb-shop-tile--wide", "yb-shop-tile--tall");
        if (index === 1) tile.classList.add("yb-shop-tile--wide");
        if (index === 3) tile.classList.add("yb-shop-tile--tall");
      });
      featured.concat(rest).forEach(function (tile) {
        grid.appendChild(tile);
      });
    });
  }

  function redirectEmptySearch() {
    if (!document.body.classList.contains("template-search")) return;
    var params = new URLSearchParams(window.location.search);
    if (!params.get("q")) return;
    var cards = document.querySelectorAll(
      ".template-search .product-card, .template-search .card-product, .template-search .grid-product, .template-search .product-item",
    );
    var emptyCopy = document.body.innerText || "";
    if (cards.length === 0 && /no products|0 results|didn't find/i.test(emptyCopy)) {
      window.location.replace("/collections/all");
    }
  }

  function escHtml(s) {
    return String(s)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;");
  }

  function renderLiveTree(tree) {
    if (!tree || !tree.length) return;
    var html = tree
      .map(function (node) {
        var kids = node.children || [];
        var childLis = kids
          .map(function (c) {
            return (
              '<li class="yb-cat-l2-item"><a class="yb-cat-l2-link" href="' +
              escHtml(c.href) +
              '">' +
              escHtml(c.displayName) +
              "</a></li>"
            );
          })
          .join("");
        var panel = kids.length
          ? '<div class="yb-cat-l2-panel" role="group" aria-label="' +
            escHtml(node.displayName) +
            ' subcategories"><a class="yb-cat-l2-all" href="' +
            escHtml(node.href) +
            '">Shop all ' +
            escHtml(node.displayName) +
            '</a><ul class="yb-cat-l2">' +
            childLis +
            "</ul></div>"
          : "";
        var chevron = kids.length
          ? '<button type="button" class="yb-cat-toggle" data-yb-toggle aria-expanded="false" aria-label="Show ' +
            escHtml(node.displayName) +
            ' categories"><span class="yb-cat-chevron"></span></button>'
          : "";
        return (
          '<li class="yb-cat-l1-item' +
          (kids.length ? " has-children" : "") +
          '"><div class="yb-cat-l1-row"><a class="yb-cat-l1-link" data-yb-parent-link href="' +
          escHtml(node.href) +
          '">' +
          escHtml(node.displayName) +
          "</a>" +
          chevron +
          "</div>" +
          panel +
          "</li>"
        );
      })
      .join("");
    document.querySelectorAll("[data-yb-cat-nav]").forEach(function (nav) {
      var list = nav.querySelector("ul.yb-cat-l1") || nav.querySelector("ul");
      if (list) list.innerHTML = html;
    });
    var footer = document.querySelector(".yb-footer-cats");
    if (footer) {
      var featured = tree.slice().sort(function (a, b) {
        return Number(b.productCount || 0) - Number(a.productCount || 0) ||
          String(a.displayName).localeCompare(String(b.displayName));
      }).slice(0, 6);
      footer.innerHTML =
        featured
          .map(function (n) {
            return (
              '<li><a href="' +
              escHtml(n.href) +
              '" class="link link-underline list-menu__item--link"><span class="text">' +
              escHtml(n.displayName) +
              "</span></a></li>"
            );
          })
          .join("") +
        '<li class="yb-footer-see-all"><a href="/collections/all" class="link link-underline list-menu__item--link"><span class="text">See all categories</span></a></li>';
    }
  }

  // P1-B: one network fetch per page load (shared in-flight / completed promise).
  var categoryTreePromise = null;
  function hydrateCategoryTree() {
    if (categoryTreePromise) return categoryTreePromise;
    categoryTreePromise = fetch(
      "https://portal.yambaba.ae/api/storefront-category-tree?shop=yambaba-store.myshopify.com",
      { cache: "no-store" },
    )
      .then(function (r) {
        return r.json();
      })
      .then(function (data) {
        if (data && data.ok && data.tree) renderLiveTree(data.tree);
      })
      .catch(function () {});
    return categoryTreePromise;
  }

  function hideSoldOutBuyItNow() {
    var add = document.querySelector(
      'form[action*="/cart/add"] [name="add"][disabled], .product-form [name="add"][disabled], button[name="add"][disabled]',
    );
    if (!add && !/sold out/i.test((document.querySelector("form.product-form, .product-form") || {}).textContent || "")) {
      return;
    }
    if (!add) return;
    document.body.classList.add("yb-sold-out-product");
    document.querySelectorAll(".shopify-payment-button, [data-shopify='payment-button']").forEach(function (el) {
      el.style.display = "none";
      el.setAttribute("hidden", "");
    });
  }

  function renamePopularHeading() {
    document.querySelectorAll("h2, h3, .title").forEach(function (el) {
      var t = (el.textContent || "").replace(/\s+/g, " ").trim();
      if (t === "Popular Products") el.textContent = "Explore YamBaba";
    });
  }

  function hidePlaceholderRelated() {
    document.querySelectorAll("a, .product-card, .card-product, .related-products li, .recently-viewed li").forEach(function (el) {
      var t = (el.textContent || "").replace(/\s+/g, " ").trim();
      if (!/^Example product title$/i.test(t) && t.indexOf("Example product title") === -1) return;
      var card = el.closest("li, .product-card, .card-product, .grid__item") || el;
      card.style.display = "none";
      card.setAttribute("hidden", "");
    });
    document.querySelectorAll(".related-products, .product-related, .recently-viewed").forEach(function (section) {
      var leftover = Array.prototype.slice.call(section.querySelectorAll("a, .product-card")).filter(function (n) {
        return n.getAttribute("hidden") == null && n.offsetParent !== null && !/Example product title/i.test(n.textContent || "");
      });
      if (leftover.length === 0) {
        var wrap = section.closest(".shopify-section, .section") || section;
        wrap.style.display = "none";
        wrap.setAttribute("hidden", "");
      }
    });
    document.querySelectorAll("h2, h3, h4").forEach(function (h) {
      var t = (h.textContent || "").replace(/\s+/g, " ").trim();
      if (!/^Related Products$/i.test(t) && !/^Recently Viewed Products$/i.test(t)) return;
      var wrap = h.closest(".shopify-section, .section") || h.parentElement;
      if (!wrap) return;
      var leftover = Array.prototype.slice.call(wrap.querySelectorAll("a.full-unstyled-link, .card-product, .product-card, .card__heading")).filter(function (n) {
        return n.getAttribute("hidden") == null && n.offsetParent !== null && !/Example product title/i.test(n.textContent || "");
      });
      if (leftover.length === 0) {
        wrap.style.display = "none";
        wrap.setAttribute("hidden", "");
      }
    });
  }

  function hideDeveloperFooter() {
    document.querySelectorAll("a, li, span, p, small, div").forEach(function (el) {
      var t = (el.textContent || "").replace(/\s+/g, " ").trim();
      if (!/developer teams/i.test(t) && !/theme by/i.test(t)) return;
      if (t.length > 80) return;
      var item = el.closest("li") || el;
      item.style.display = "none";
      item.setAttribute("hidden", "");
    });
  }

  function hideBrokenCategoryAssets() {
    document.querySelectorAll("img").forEach(function (img) {
      function hide() {
        img.style.display = "none";
        img.setAttribute("hidden", "");
        img.removeAttribute("src");
        img.removeAttribute("srcset");
        if (img.parentElement && img.parentElement.classList.contains("yb-collection-cats__thumb")) {
          var span = document.createElement("span");
          span.className = "yb-collection-cats__thumb-fallback";
          span.setAttribute("aria-hidden", "true");
          img.replaceWith(span);
        }
      }
      img.addEventListener("error", hide);
      if (img.complete && img.naturalWidth === 0 && img.getAttribute("src")) hide();
    });
  }

  function polishMarketingCopy() {
    var map = {
      "School style for less": "Shop Home & Living",
      "Start their playcation": "Shop Baby & Kids",
    };
    document.querySelectorAll("h1,h2,h3,h4,a,p,span").forEach(function (el) {
      var t = (el.childNodes.length === 1 && el.childNodes[0].nodeType === 3)
        ? (el.textContent || "").replace(/\s+/g, " ").trim()
        : "";
      if (map[t]) el.textContent = map[t];
    });
  }

  hydrateCategoryTree();
  hideSoldOutBuyItNow();
  renamePopularHeading();
  hidePlaceholderRelated();
  hideDeveloperFooter();
  hideBrokenCategoryAssets();
  polishMarketingCopy();
  document.addEventListener("DOMContentLoaded", function () {
    hydrateCategoryTree();
    hideSoldOutBuyItNow();
    renamePopularHeading();
    hidePlaceholderRelated();
    hideDeveloperFooter();
    hideBrokenCategoryAssets();
    polishMarketingCopy();
  });
})();
